<template>
  <div
      id="congratulationsmodal"
      class="modal fade"
      style="background: rgba(0,0,0,0.5)"
      :class="{ show: show }"
      tabindex="-1"
      role="dialog"
      aria-labelledby="vcenter"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        style="display: flex; justify-content: center"
      >
        <div class="modal-content" id="modal">
          <div class="card-body">
            <div class="mt-4 text-center">
              <img
                class="mt-3"
                width="88px"
                height="88px"
                src="../../assets/images/party.jpg"
              />
            </div>
            <div class="mt-5 mb-4 text-center mx-auto col-md-8">
              <h4>Congratulations!</h4>
              <h4 class="mb-4">One Year Premium Subscription</h4>
              <p>
                You now have access to:
              </p>
            </div>

            <div class="mx-auto col-md-12">
              <div class="row mb-2">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-2">
                      <i class="fas fa-check text-success font-18"></i>
                    </div>
                    <div class="col-10">Temperature Monitoring</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-2">
                      <i class="fas fa-check text-success font-18"></i>
                    </div>
                    <div class="col-10">Humidity Monitoring</div>
                  </div>
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-2">
                      <i class="fas fa-check text-success font-18"></i>
                    </div>
                    <div class="col-10">Location/GPS Tracking</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-2">
                      <i class="fas fa-check text-success font-18"></i>
                    </div>
                    <div class="col-10">Receive alarms by email</div>
                  </div>
                </div>
              </div>
              <div class="row mb-4">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-2">
                      <i class="fas fa-check text-success font-18"></i>
                    </div>
                    <div class="col-10">Download quality assurance report</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mb-4">
              <button
                @click.prevent="closeCongratulations"
                class="btn btn-primary"
              >
                Got it!
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "CongratulationsModal",
  props: {
    show: Boolean,
    deviceTag: String
  },
  methods: {
    closeCongratulations() {
      this.$emit("closeCongratulationsModal");
      this.isLoading = true;
      // setTimeout(() => {
        this.$router.push(`/devices/setupdevice/${this.deviceTag}`);
        // this.$router.push(`/devices/setupdevice/GRD002329`);
      // }, 1000);
    },
  }
}
</script>



<style scoped>
.modal-dialog {
  max-width: 500px !important;
}
</style>